import type { GivingDetail } from 'models';
import { useState } from 'react';
import { Button, Card, Col, Icon, Row } from 'ui';
import type { TransactionResultParams } from 'features/transactions';
import { GivingCreateModal, type GivingCreateModalType } from '../../giving-create-modal';
import { GivingTransactionResultModal } from '../../giving-transaction-result-modal';
import { useIsGivingOngoing } from '../../hooks';

type P = {
  giveTransaction: TransactionResultParams;
  giving: GivingDetail;
  paymentRedirectUrl: string;
};

const DonateButtons = ({ giveTransaction, giving, paymentRedirectUrl }: P) => {
  const isGivingOngoing = useIsGivingOngoing({ giving });
  const [givingModalType, setGivingModalType] = useState<GivingCreateModalType>();

  if (!isGivingOngoing) {
    return null;
  }

  return (
    <>
      <Card>
        <Row gutter={['xs', 'xs']}>
          <Col span={24}>
            <Button
              block
              icon={<Icon icon="hand-heart-line" />}
              onClick={() => {
                setGivingModalType('default');
              }}
              type="primary"
            >
              Give
            </Button>
          </Col>
        </Row>
      </Card>
      <GivingCreateModal
        giving={giving}
        isOpened={Boolean(givingModalType)}
        onClose={() => {
          setGivingModalType(undefined);
        }}
        paymentRedirectUrl={paymentRedirectUrl}
        type={givingModalType}
      />

      <GivingTransactionResultModal
        giving={giving}
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        isOpened={Boolean(giveTransaction?.transactionResult)}
        onClose={() => {
          giveTransaction.onModalClose();
        }}
        result={giveTransaction.transactionResult}
      />
    </>
  );
};

export default DonateButtons;
